export const MAX_WORDS_IF_HIDDEN = 60;
export const MAX_IMAGES_IF_HIDDEN = 3;
export const MAX_ROWS_IF_HIDDEN = 8;
